module.exports = __webpack_public_path__ + "static/media/book2.436a05cc.png";